// Mock data for KargoPack website

export const heroSlides = [
  {
    id: 1,
    title: "Güçlü ve Dayanıklı",
    subtitle: "Çözümler!",
    description: "Yüksek kaliteli malzemeler ve yırtılmaya karşı dayanıklı tasarım ile ürünlerinizi güvenle taşıyın.",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/rvgkr5ad_dayan%C4%B1kl%C4%B1cozumler.jpg",
    buttonText: "DETAY",
    buttonLink: "/urunler"
  },
  {
    id: 2,
    title: "Yeni",
    subtitle: "Ürünler!",
    description: "Baskılı ve baskısız kargo poşetlerimizle markanıza özel çözümler sunuyoruz.",
    image: "https://images.unsplash.com/photo-1617912760778-f3a1b93192ad",
    buttonText: "DETAY",
    buttonLink: "/urunler"
  },
  {
    id: 3,
    title: "İhtiyacınızın",
    subtitle: "Şekli!",
    description: "Farklı boyutlarda ve özelliklerde kargo poşetleri ile her ihtiyaca uygun çözümler.",
    image: "https://images.unsplash.com/photo-1685119166946-d4050647b0e3",
    buttonText: "DETAY",
    buttonLink: "/urunler"
  },
  {
    id: 4,
    title: "Güçlü Görsel",
    subtitle: "Etki!",
    description: "Yüksek kaliteli baskı teknolojisi ile markanızı öne çıkarın.",
    image: "https://images.unsplash.com/photo-1617912759452-71732a8da839",
    buttonText: "DETAY",
    buttonLink: "/urunler"
  }
];

export const companyStats = [
  {
    id: 1,
    icon: "calendar",
    number: "15+",
    label: "Yıllık Tecrübe"
  },
  {
    id: 2,
    icon: "users",
    number: "1000+",
    label: "Mutlu Müşteri"
  },
  {
    id: 3,
    icon: "globe",
    number: "10+",
    label: "İhracat Ülkesi"
  },
  {
    id: 4,
    icon: "package",
    number: "1.500 m²",
    label: "Fabrika Alanı"
  },
  {
    id: 5,
    icon: "building",
    number: "150M",
    label: "Adet Kapasite"
  },
  {
    id: 6,
    icon: "factory",
    number: "750 Ton",
    label: "Yıllık Kapasite"
  }
];

export const productGroups = [
  {
    id: 1,
    name: "Kargo Poşeti",
    description: "Müşteri isteğine göre üretilir, 60-200 mikron, 8 renge kadar",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/kfk9n0c0_kargopo%C5%9Feti.png",
    link: "/urunler"
  },
  {
    id: 2,
    name: "Torba",
    description: "Müşteri isteğine göre üretilir, 60-200 mikron",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/f94eqdb5_zipbag.png",
    link: "/urunler"
  },
  {
    id: 3,
    name: "Koli Bandı",
    description: "40-70 mm arası, standart kalınlık",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/8ia2op6j_koliband%C4%B1.jpg",
    link: "/urunler"
  },
  {
    id: 4,
    name: "Jelatin",
    description: "Müşteri isteğine göre üretilir, 60-100 mikron, şeffaf",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/zyfvw85g_jelatin.png",
    link: "/urunler"
  }
];

export const blogPosts = [
  {
    id: 1,
    title: "E-Ticaret İçin Doğru Kargo Poşeti Nasıl Seçilir?",
    image: "https://images.unsplash.com/photo-1633533452148-a9657d2c9a5f",
    excerpt: "E-ticaret işletmeniz için en uygun kargo poşetini seçerken dikkat etmeniz gereken önemli noktalar.",
    link: "/blog/dogru-kargo-poseti-secimi",
    date: "15 Ocak 2025"
  },
  {
    id: 2,
    title: "Sürdürülebilir Ambalaj Çözümleri",
    image: "https://images.pexels.com/photos/1267338/pexels-photo-1267338.jpeg",
    excerpt: "Çevre dostu plastik ambalaj üretimi ve geri dönüşüm süreçlerimiz hakkında bilgiler.",
    link: "/blog/surdurulebilir-ambalaj",
    date: "10 Ocak 2025"
  },
  {
    id: 3,
    title: "Baskılı Kargo Poşetlerinin Marka İmajına Katkısı",
    image: "https://images.unsplash.com/photo-1685119166946-d4050647b0e3",
    excerpt: "Özel tasarım baskılı kargo poşetleri ile markanızı nasıl güçlendirebilirsiniz?",
    link: "/blog/baskili-poseti-marka-imaji",
    date: "5 Ocak 2025"
  }
];

export const products = [
  {
    id: 1,
    name: "Baskılı/Baskısız Kargo Poşeti",
    category: "Kargo Poşeti",
    size: "Müşteri isteğine göre üretilir",
    thickness: "60-200 mikron",
    color: "8 renge kadar",
    price: "Fiyat için iletişime geçin",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/kfk9n0c0_kargopo%C5%9Feti.png"
  },
  {
    id: 2,
    name: "Zipli/Kilitli Torba",
    category: "Torba",
    size: "Müşteri isteğine göre üretilir",
    thickness: "60-200 mikron",
    color: "Şeffaf/Buzlu/Özel Renkli",
    price: "Fiyat için iletişime geçin",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/f94eqdb5_zipbag.png"
  },
  {
    id: 3,
    name: "Baskılı Koli Bandı",
    category: "Koli Bandı",
    size: "40-70 mm arası",
    thickness: "Standart",
    color: "Çok Renkli",
    price: "Fiyat için iletişime geçin",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/8ia2op6j_koliband%C4%B1.jpg"
  },
  {
    id: 4,
    name: "Jelatin",
    category: "Jelatin",
    size: "Müşteri isteğine göre üretilir",
    thickness: "60-100 mikron",
    color: "Şeffaf",
    price: "Fiyat için iletişime geçin",
    image: "https://customer-assets.emergentagent.com/job_kargo-pouch/artifacts/zyfvw85g_jelatin.png"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Ahmet Yılmaz",
    company: "E-Ticaret Mağazası Sahibi",
    text: "KargoPack ile çalışmaya başladıktan sonra müşteri memnuniyetimiz arttı. Kaliteli ve dayanıklı ürünler.",
    rating: 5
  },
  {
    id: 2,
    name: "Ayşe Demir",
    company: "Online Butik",
    text: "Baskılı kargo poşetleri sayesinde markamız daha profesyonel görünüyor. Teşekkürler!",
    rating: 5
  },
  {
    id: 3,
    name: "Mehmet Kaya",
    company: "Lojistik Şirketi",
    text: "Hızlı teslimat ve uygun fiyatlar. Sürekli çalıştığımız bir tedarikçi oldular.",
    rating: 5
  }
];

export const features = [
  {
    id: 1,
    icon: "shield-check",
    title: "Sağlıklı ve Dayanıklı",
    description: "Yüksek kaliteli hammadde ile üretilen, dayanıklı ve güvenli ambalaj çözümleri."
  },
  {
    id: 2,
    icon: "zap",
    title: "Hızlı Teslimat",
    description: "Stoklu ürünlerde 24 saat içinde kargo, özel üretimlerde 7-10 iş günü teslimat."
  },
  {
    id: 3,
    icon: "leaf",
    title: "Çevre Dostu",
    description: "Geri dönüştürülebilir malzemeler ve sürdürülebilir üretim süreçleri."
  },
  {
    id: 4,
    icon: "award",
    title: "Kalite Garantisi",
    description: "ISO sertifikalı üretim ve %100 müşteri memnuniyeti garantisi."
  }
];

export const contactInfo = {
  phone: "+90 541 828 46 44",
  whatsapp: "+905418284644",
  email: "satis@kargopack.com",
  address: "Yenibosna Merkez Mah. Muştu Sok. No:21B Bahçelievler/İSTANBUL",
  workingHours: "Pazartesi - Cuma: 09:00 - 18:00"
};

export const references = [
  {
    id: 1,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+1"
  },
  {
    id: 2,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+2"
  },
  {
    id: 3,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+3"
  },
  {
    id: 4,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+4"
  },
  {
    id: 5,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+5"
  },
  {
    id: 6,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+6"
  },
  {
    id: 7,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+7"
  },
  {
    id: 8,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+8"
  },
  {
    id: 9,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+9"
  },
  {
    id: 10,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+10"
  },
  {
    id: 11,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+11"
  },
  {
    id: 12,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+12"
  },
  {
    id: 13,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+13"
  },
  {
    id: 14,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+14"
  },
  {
    id: 15,
    image: "https://via.placeholder.com/200x100/E31E24/FFFFFF?text=Logo+15"
  }
];
